<div class="custom-navbar">
  @if (canGoBack) {
    <div class="back-button">
      <button class="btn btn-lg btn-default btn-back" (click)="onBack.emit()">
        <i class="fas fa-chevron-left"></i>
      </button>
    </div>
  }
  <div class="shadow-sm rounded text-center py-2">
    MENU
  </div>
</div>
